import { IDLabel } from "../../models/common/CommonModels";

export enum Airline {
  Column = "airlineColumn",
  Operator = "airlineOperator",
  Values = "airlineValues",
  Name = "Airlines",
}

const airlineFieldControlDetails = {
  column: {
    label: "Column",
    name: Airline.Name,
    fieldName: Airline.Column,
    isMandatory: false,
  },
  operator: {
    label: "Operator",
    fieldName: Airline.Operator,
    isMandatory: true,
    inputType: "string",
  },
  values: {
    label: "Value(s)",
    fieldName: Airline.Values,
    isMandatory: false,
    inputType: "tagPicker",
  },
};

const GlobalFilterColumnsDetails = {
  [Airline.Name]: {
    fieldControls: Airline,
    fieldControlDetails: airlineFieldControlDetails,
  },
};

const GlobalFilterColumns = [Airline.Name];

const GlobalFilterEnum = {
  filterColumns: GlobalFilterColumns,
  filterColumnsDetails: GlobalFilterColumnsDetails,
};

export default GlobalFilterEnum;

export interface IFilterOptionsConfig {
  id: string;
  label: string;
}

export enum GlobalFilterOptionsEnum {
  today = "today",
  custom = "custom",
  rolling = "rolling",
}

export const GLOBAL_FILTER_OPTIONS_CONFIG = [
  { id: GlobalFilterOptionsEnum.rolling, label: "Rolling" },
  { id: GlobalFilterOptionsEnum.today, label: "Today" },
  { id: GlobalFilterOptionsEnum.custom, label: "Custom" },
];

export enum TodayFilterOptionsEnum {
  now = "now",
  day = "day",
}

export const TodayFilterOptions: IDLabel[] = [
  { id: TodayFilterOptionsEnum.day, label: "24 Hrs" },
  { id: TodayFilterOptionsEnum.now, label: "00:00 till current time" },
];

export type RollingHoursInput = {
  fromRollingHours: number;
  fromRollingMinute: number;
  toRollingHours: number;
  toRollingMinute: number;
};

export type RollingHoursOutput = {
  addFromRollingHours: number;
  addToRollingHours: number;
};

export interface IAppliedFilterValues {
  selectedOption: string;
  fromRollingHours: number;
  fromRollingMinute: number;
  toRollingHours: number;
  toRollingMinute: number;
  fromDate: Date;
  toDate: Date;
  todayOption: TodayFilterOptionsEnum;
}
